<template>
    <div class="body_area after_bg sm">

        <div class="block-header">
            <div class="container">
                <div class="row clearfix">
                    <div class="col-lg-6 col-md-12">
                        <h1 class="mb-1 mt-1">리드</h1>
                    </div>
                </div>
                <div class="bh_divider"></div>
                <div class="row clearfix">
                    <div class="col-lg-12 col-md-12">
                        <nav class="navbar navbar-expand-lg page_menu">
                            <!--              hih   <a class="navbar-brand" href="javascript:void(0);">A.</a>-->
                            <!--              <a class="navbar-brand" href="javascript:void(0);">A.</a>-->
                            <!--              <button class="btn btn-default btn-sm" type="button" data-toggle="collapse" style="display: block;">-->
                            <!--                <span>메뉴</span>-->
                            <!--              </button>-->


                            <div class="collapse navbar-collapse" id="Blog_app" style="display: block;"  @mouseleave="activeHover(1)">
                                <ul class="navbar-nav mr-auto">
                                    <li class="nav-item active "><a href="javascript:void(0);" class="nav-link"  @click="toLeadPage">리드</a></li>
                                    <li class="nav-item "><a href="javascript:void(0);" class="nav-link"  @click="toListPage">리스트</a></li>
                                </ul>
                                <div>
                                    <button type="button" class="btn btn-secondary" @mouseenter="activeHover(0)" >리드 추가 </button> &nbsp;
                                    <!--                  <button type="button" class="btn btn-secondary" @click="exportLead">리드 내보내기</button>-->
                                    <!--                  <button type="button" class="btn btn-secondary" @click="toAddLeadPage">리드 추가</button>-->
                                    <div style="position: relative;" :class="{'active' : btnShow , 'hidden' : !btnShow}" >
                                        <ul class="list dropList" >
                                            <li>
                                                <ul class="ml-menu" style="display: block; list-style: none; padding: 0;">
                                                    <!--                          <li><a href="javascript:void(0);" @click="addByCSV(0)">CSV 추가</a></li>-->
                                                    <li ><a href="javascript:void(0);" @click="toAddLeadPage">리드 추가</a></li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </div>




                                    <!--                  <button type="button" class="btn btn-secondary" @click="toAddLeadPage">리드 추가</button>-->
                                    <!--                  <button type="button" class="btn btn-secondary" @click="addByCSV">CSV 추가</button>-->
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row clearfix row-deck">
                <div class="col-lg-7 col-md-12">
                    <div class="card visitors-map">


                        <div class="header">
                            <div class="input-group search">
                                <input type="text" class="form-control" placeholder="리드명" v-model="keyword">
                                <div class="input-group-append"></div>
                                <span class="input-group-text"><i class="zmdi zmdi-search"></i></span>
                            </div>
                            <!--              <h2>리드</h2>-->
                        </div>

                        <div class="table-responsive" style="min-height: 500px;">
                            <table class="table table-hover mb-0" style="text-align: center;">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>이메일</th>
                                    <th>생성일</th>
                                    <th>설정</th>
                                </tr>
                                </thead>
                                <tbody v-if="leads != null && leads.length != 0">
                                <tr v-for="(lead, index) of leads" v-bind:key="index">
                                    <td>{{countingIndex(index)}}</td>
                                    <td @click="detailLead(index)">{{lead.email}}</td>
                                    <td>{{lead.insertDt}}</td>
                                    <td>
                                        <a href="javascript:void(0);" class="btn btn-sm btn-success" @click="leadEdit(lead.leadCode)" style="color: white;"><font-awesome-icon :icon="faPen"></font-awesome-icon></a>
                                        &nbsp;
                                        <a href="javascript:void(0);" class="btn btn-sm btn-danger" @click="leadDelete(lead.leadCode)"> <font-awesome-icon :icon="faTrash"></font-awesome-icon>  </a>
                                        &nbsp;
                                        <a href="javascript:void(0);" class="btn btn-sm btn-primary" @click="leadAddList(lead.leadCode)"> <font-awesome-icon :icon="faPlus"></font-awesome-icon> </a>
                                    </td>
                                </tr>


                                </tbody>

                                <tbody v-if="leads == null || leads.length == 0">
                                <tr >
                                    <td colspan="4"> 리드가 없습니다. </td>
                                </tr>


                                </tbody>

                            </table>
                        </div>
                        <div>
                            <div class="justify-content-center">
                                <ul class="pagination pagination-primary" style="justify-content: center;">
                                    <li class="page-item arrow-margin-left" v-if="pageNum > 1" @click="changePage(1)">
                                        <a class="page-link" href="javascript:void(0);" aria-label="Previous" >
                                            <span aria-hidden="true"><i class="zmdi zmdi-chevron-left" aria-hidden="true"></i></span>
                                        </a>
                                    </li>

                                    <li class="page-item" :class="{'active' : pageNum == num}" v-for="num in Math.ceil(totalCount/30)" :key="num" @click="changePage(num)"><a class="page-link" href="javascript:void(0);">{{num}}</a></li>

                                    <li class="page-item arrow-margin-right" v-if="Math.ceil(totalCount/30) > 1" @click="changePage(pageNum +1)">
                                        <a class="page-link" href="javascript:void(0);" aria-label="Next" >
                                            <span aria-hidden="true"><i class="zmdi zmdi-chevron-right" aria-hidden="true"></i></span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-5 col-md-12">
                    <div class="card">
                        <div class="header">
                            <h2>상세 조회</h2>

                        </div>
                        <div class="container" v-if="!clickedLead" style="min-height: 500px;">
                            리드를 클릭
                        </div>
                        <div class="container" v-if="clickedLead">
                            <!-- Example Tab -->
                            <div class="row clearfix">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <div class="body">
                                        <!-- Nav tabs -->
                                        <ul class="nav nav-tabs">
                                            <li class="nav-item"><a class="nav-link" data-toggle="tab" href="javascript:void(0);" :class="{'active' : sideTab == 0}" @click="sideShowProfile(0)">활동정보</a></li>
                                            <li class="nav-item"><a class="nav-link" data-toggle="tab" href="javascript:void(0);" :class="{'active' : sideTab == 1}" @click="sideShowProfile(1)">프로필</a></li>
                                            <li class="nav-item"><a class="nav-link" data-toggle="tab" href="javascript:void(0);" :class="{'active' : sideTab == 2}" @click="sideShowProfile(2)">리스트</a></li>
                                        </ul>
                                        <!-- Tab panes -->
                                        <div class="tab-content mt-3" style="min-height: 500px;">
                                            <div role="tabpanel" class="tab-pane in" id="home" :class="{'active' : sideTab == 0}">
                                                <div class="body">
                                                    <div class="panel-group" id="accordion_1" role="tablist" aria-multiselectable="true">
                                                        <div class="panel" v-for="(track, index) in tracking" :key="index">
                                                            <div class="panel-heading" role="tab" id="headingOne_1" @click="collapsedBox(index)" >
                                                                <h4 class="panel-title">
                                                                    <a role="button" data-toggle="collapse" data-parent="#accordion_1" href="#collapseOne_1" aria-expanded="true" aria-controls="collapseOne_1">방문한 페이지 : {{track.pageName}}</a>
                                                                </h4>
                                                            </div>
                                                            <div class="panel-collapse collapse in show trackingCollapse" role="tabpanel" aria-labelledby="headingOne_1" style="display: none;">
                                                                <div class="panel-body">

                                                                    <ul>
                                                                        <li>url :
                                                                            <br>{{track.url}}
                                                                        </li>
                                                                        <li>페이지 제목 : <br>{{track.title}}</li>
                                                                        <li>접속 IP : <br>{{track.remoteAddr}}</li>
                                                                        <li>OS : <br>{{track.os}}</li>
                                                                        <li>접속 브라우저 : {{track.browserName}} <br>({{track.browserVersion}})</li>
                                                                    </ul>

                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    <div class="panel-group" id="accordion_2" role="tablist" aria-multiselectable="true" v-if="tracking == null || tracking.length == 0">
                                                        <div class="panel" >
                                                            <div class="panel-heading" role="tab" id="headingOne_2"  >
                                                                <h4 class="panel-title">
                                                                    <a role="button" data-toggle="collapse" data-parent="#accordion_1" href="#collapseOne_1" aria-expanded="true" aria-controls="collapseOne_1">활동 정보가 없습니다.</a>
                                                                </h4>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div role="tabpanel" class="tab-pane" id="profile" :class="{'active' : sideTab == 1}">
                                                <p>이메일 : {{email}}</p>
                                                <p>이름 : {{name}}</p>
                                                <p>나이 : {{age}}</p>
                                                <p>전화번호 : {{phone}}</p>
                                                <p>회사 : {{company}}</p>
                                                <p>생년월일 : {{birthday}}</p>
                                                <p>성별 : {{gender}}</p>
                                                <p>우편번호 : {{zipcode}}</p>
                                                <p>주소 : {{address1}}</p>
                                                <p>상세주소 : {{address2}}</p>
                                                <p>리드점수 : {{leadScore}}</p>
                                            </div>
                                            <div role="tabpanel" class="tab-pane" id="messages" :class="{'active' : sideTab == 2}">
                                                <div class="table-responsive">
                                                    <table class="table table-hover mb-0" >
                                                        <thead>
                                                        <tr>
                                                            <th>리스트명</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody v-if="listGroup != null && listGroup.length != 0">
                                                        <tr v-for="(lead, index) of listGroup" v-bind:key="index">
                                                            <td>{{lead.leadGroupTitle}}</td>
                                                        </tr>
                                                        </tbody>
                                                        <tbody v-if="listGroup == null || listGroup.length == 0">
                                                        <tr >
                                                            <td colspan="4"> 등록된 리스트가 없습니다. </td>
                                                        </tr>


                                                        </tbody>

                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- #END# Example Tab -->
                        </div>
                    </div>
                </div>
            </div>
            <footer-view />
        </div>



        <div v-if="csvModal" >
            <div class="modal fade show" id="defaultModal" tabindex="-1" role="dialog" style="top:140px;">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="title" id="defaultModalLabel">CSV로 리드 추가</h4>
                        </div>
                        <div class="modal-body" style="overflow: scroll; height: 650px;">
                            <div>
                                이미지
                                <br>
                                <br>
                                <br>
                                <input type="file" value="파일 업로드"/>
                                <br>
                                <br>
                                <br>
                                <button class="btn btn-primary" type="button">등록</button>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <!--                <button type="button" class="btn btn-primary waves-effect">선택</button>-->
                            <button type="button" class="btn btn-danger btn-simple waves-effect" data-dismiss="modal" @click="addByCSV(1)">닫기</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div v-if="listModal" >
            <div class="modal fade show" id="defaultModal1" tabindex="-1" role="dialog" style="top:140px;">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="title" id="defaultModalLabel1">리스트에 리드 추가</h4>
                        </div>
                        <div class="modal-body" >
                            <div>
                                <div class="body">
                                    <div class="row clearfix">
                                        <div class="col-sm-12">
                                            <select class="form-control show-tick" v-model="listCode">
                                                <option value="">-- 선택 --</option>
                                                <option v-for="(list, index) in lists " :key="index"  :value="list.leadGroupCode" >
                                                    {{list.leadGroupTitle}}
                                                </option>
                                            </select>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary waves-effect" @click="addLeadToList">추가</button>
                            <button type="button" class="btn btn-danger btn-simple waves-effect" data-dismiss="modal" @click="closeListModal">닫기</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>


<script>
import FooterView from "@/components/common/FooterView";
import ResultCode from "@/service/ResultCode";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// import { fa } from "@fortawesome/free-regular-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export default {
    name: 'LeadListPage',
    components: {
        FooterView,
        FontAwesomeIcon,

    },
    data() {
        return {
            sideTab : 1,
            btnShow : false,
            csvModal : false,
            clickedLead : false,

            keyword:null,

            email : null,
            name : null,
            age : null,
            gender : null,
            birthday : null,
            company : null,
            phone : null,
            zipcode : null,
            address1 : null,
            address2 : null,
            leadScore : null,
            leadCode : null,

            leads : null,
            tracking : null,
            listGroup : null,

            lists : null,
            listModal : false,
            listCode : "",

            pageNum : 1,
            totalCount : 2,

            planName : null,
            planType : null,
            flowCount : 0,
            flowTotal : 0,
            workCount : 0,
            workTotal : 0,
            leadCount : 0,
            leadTotal : 0,

            faPlus,
            faPen,
            faTrash,
        }
    },
    methods: {
        countingIndex(index){

            return this.totalCount - (this.pageNum -1)*20 - index
        },
        changePage(num){
            this.pageNum = num;

            this.getLeads();

        },
        addLeadToList(){
            console.log("선택", this.listCode)

            var param = {
                companyCode : this.$store.getters.getUserCode,
                leadGroupCode : this.listCode,
                leadCode : this.leadCode
            }

            this.api.addLeadsToLists(param)
                .then((res)=>{
                    console.log(res)
                    if(res.code == 0){
                        alert("추가되었습니다.")

                    } else {
                        alert(res.code)
                    }

                    this.closeListModal();

                })

        },
        closeListModal(){
            this.listModal = false;
        },
        leadAddList(code){
            console.log(code)

            this.leadCode = code;

            var param = {
                companyCode : this.$store.getters.getUserCode
            }

            console.log(param)

            this.api.getListNoPaging(param)
                .then((res)=>{
                    console.log(res)

                    if(this.utils.preApiHandle(res)) {
                        console.log("list list res : ", res)
                    }

                    if(res.code == 0){
                        this.lists = res.listList;
                        this.listModal = true;

                    } else if(res.code === ResultCode.AlreadyExist){
                        alert("등록이 되어있는 리드입니다.")
                    } else {
                        alert("오류가 발생했습니다.")

                    }

                })


        },
        leadDelete(code){
            if(confirm("삭제하시겠습니까?")){
                var param = {
                    companyCode : this.$store.getters.getUserCode,
                    leadCode : code
                }

                this.api.removeLead(param)
                    .then((res)=>{

                        if(this.utils.preApiHandle(res)) {
                            console.log("list list res : ", res)
                        }

                        if(res.code == 0){
                            alert("삭제되었습니다.")
                            this.getLeads();
                        } else {
                            alert("오류가 발생했습니다.")

                        }

                    })

            }

        },
        getLeadTrackGroups(){
            var param = {
                companyCode : this.$store.getters.getUserCode,
                leadCode : this.leadCode
            }

            console.log("get tracking")

            this.api.getLeadTracking(param)
                .then((res)=>{
                    console.log(res)

                    if(this.utils.preApiHandle(res)) {
                        console.log("list list res : ", res)
                    }

                    if(res.code == 0){
                        this.tracking = res.tracking;

                    } else {
                        alert("오류가 발생했습니다.")
                    }

                })


            this.api.getLeadsList(param)
                .then((res)=>{

                    if(this.utils.preApiHandle(res)) {
                        console.log("profile edit res : ", res)
                    }


                    console.log(res)

                    this.listGroup = res.list;

                })
        },
        leadEdit(code){
            console.log(code)
            this.$router.push({name:'LeadAddPage', params : {leadCode : code, status : '0'}})
        },
        collapsedBox(index){

            if(document.getElementsByClassName("trackingCollapse")[index].style.display == "none"){
                document.getElementsByClassName("trackingCollapse")[index].style.display = "block";
            } else {
                document.getElementsByClassName("trackingCollapse")[index].style.display = "none";
            }
        },
        detailLead(index){

            console.log(index)

            var lead = this.leads[index];

            this.leadCode = lead.leadCode
            this.email = lead.email
            this.name = lead.name
            this.age = lead.age
            this.gender = lead.gender
            this.birthday = lead.birthday
            this.company = lead.company
            this.phone = lead.phone
            this.zipcode = lead.zipcode
            this.address1 = lead.address1
            this.address2 = lead.address2
            this.leadScore = lead.leadScore

            this.clickedLead = true;

            this.getLeadTrackGroups();

        },
        sideShowProfile(num){
            this.sideTab = num;

        },
        activeHover(num){
            if(num == 0){
                this.btnShow = true;
            } else {
                this.btnShow = false;
            }
        },
        addByCSV(num){
            if(num == 0){
                this.csvModal = true;
            } else {
                this.csvModal = false;
            }
        },
        exportLead(){
            console.log('ddd')

        },
        toAddLeadPage(){
            if( this.leadTotal != -1 && (this.leadCount == this.leadTotal || this.leadCount > this.leadTotal)){
                alert("생성 가능한 최대 갯수에 도달하였습니다.")
            } else {
                this.$router.push({name:'LeadAddPage', params:{status : '0'}})

            }
        },
        toLeadPage(){
            this.$router.push({name:"LeadListPage"})
        },
        toListPage(){
            this.$router.push({name:"ListListPage"})
        },
        getLeads(){
            var param = {
                companyCode : this.$store.getters.getUserCode,
                skipNum : this.pageNum - 1,

            }

            this.api.getLeadList(param)
                .then((res)=>{
                    console.log(res)

                    if(this.utils.preApiHandle(res)) {
                        console.log("profile edit res : ", res)
                    }

                    if(res.code == 0){
                        this.leads = res.leadList;
                        this.totalCount = res.totalCount;

                        this.getTasks();

                    } else {
                        alert("오류가 발생했습니다.")
                    }

                })
        },
        getTasks(){
            this.api.getUserTask({
                companyCode : this.$store.state.userStore.userCode,
                dateOfSearch : null,
                siteCode : this.$store.state.userStore.siteCode
            })
                .then((res) => {

                    if(this.utils.preApiHandle(res)) {
                        console.log("profile create res : ", res)
                    }

                    console.log(res)
                    if (res.code == 0) {
                        console.log(res);
                        this.planName = res.task.planName
                        this.flowCount = res.task.flowCount
                        this.flowTotal = res.task.flowTotal
                        this.workCount = res.task.workCount
                        this.workTotal = res.task.workTotal
                        this.leadCount = res.task.leadCount
                        this.leadTotal = res.task.leadTotal
                        this.planType = res.task.planName

                        if(res.status == "N"){
                            alert("플랜기간이 만기했습니다.");
                            this.$router.push({name:'ProfilePage'})
                        }

                    } else {

                        alert("오류가 발생했습니다.");
                        // location.href="/";
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    },
    created() {
        console.log('LeadListPage created')
        this.getLeads();


    },
    mounted() {
        console.log('LeadListPage created')
    },
    beforeDestroy() {
        console.log('LeadListPage beforeDestroy')
    }
}
</script>
<style>
.active{
    display: block;
}
.hidden{
    display: none;
}
.dropList {
    position: absolute;
    background: #fcfcfc;
    top: -30px;
    border-radius: 5px;
    color: black;
    list-style: none;
    width: 10em;
    text-align: center;
    padding: 10px 5px 5px 5px;
}
</style>
